/**
 * GraphQL queries and hooks — health pillar.
 * Split from graphql/queries.ts (issue #1409).
 */

import { gql } from '@apollo/client';
import { useQuery, type QueryResult } from '@apollo/client/react';
import type { HealthCheckResult } from '../types/health';

/**
 * Health check query
 */
export const HEALTH_CHECK = gql`
  query HealthCheck {
    health {
      status
      timestamp
      version
      checks {
        api {
          status
          latency
          error
        }
        dynamodb {
          status
          latency
          error
        }
        okta {
          status
          latency
          error
        }
        verifiedPermissions {
          status
          latency
          error
        }
      }
    }
  }
`;

/**
 * Hook for GraphQL health check
 */
export function useGraphQLHealth(): QueryResult<{ health: HealthCheckResult }> {
  return useQuery(HEALTH_CHECK, {
    pollInterval: 30000, // Poll every 30 seconds
  });
}
